export enum SortColumn {
  ID = 'id',
  NAME = 'name',
  FIRST_NAME = 'firstName',
}
